export default __webpack_public_path__ + "static/media/MDV_5.e59cc314.png";